<template>
  <q-btn
    v-show="showButton"
    fab
    icon="keyboard_arrow_up"
    color="primary"
    class="scroll-to-top-btn"
    @click="scrollToTop"
    :class="{ visible: showButton }"
  >
    <q-tooltip class="bg-primary">Voltar ao topo</q-tooltip>
  </q-btn>
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";

export default {
  name: "ScrollToTopButton",
  props: {
    threshold: {
      type: Number,
      default: 300,
    },
    scrollElement: {
      type: [String, Object],
      default: null,
    },
  },
  setup(props) {
    const showButton = ref(false);

    const scrollToTop = () => {
      const element = getScrollElement();
      if (element === window) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      } else if (element) {
        element.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    };

    const getScrollElement = () => {
      if (!props.scrollElement) {
        return window;
      }

      if (typeof props.scrollElement === "string") {
        return document.querySelector(props.scrollElement);
      }

      return props.scrollElement;
    };

    const handleScroll = () => {
      const element = getScrollElement();
      let scrollTop = 0;

      if (element === window) {
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      } else if (element) {
        scrollTop = element.scrollTop;
      }

      showButton.value = scrollTop > props.threshold;
    };

    onMounted(() => {
      const element = getScrollElement();
      if (element) {
        element.addEventListener("scroll", handleScroll);
        handleScroll();
      }
    });

    onUnmounted(() => {
      const element = getScrollElement();
      if (element) {
        element.removeEventListener("scroll", handleScroll);
      }
    });

    return {
      showButton,
      scrollToTop,
    };
  },
};
</script>

<style scoped>
.scroll-to-top-btn {
  position: fixed;
  bottom: 52px;
  right: 20px;
  z-index: 1000;
  opacity: 0;
  transform: translateY(100px);
  transition: all 0.3s ease-in-out;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.scroll-to-top-btn.visible {
  opacity: 1;
  transform: translateY(0);
}

.scroll-to-top-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

@media (max-width: 600px) {
  .scroll-to-top-btn {
    bottom: 16px;
    right: 16px;
    width: 48px !important;
    height: 48px !important;
  }

  .scroll-to-top-btn :deep(.q-btn__content) {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .scroll-to-top-btn {
    bottom: 42px;
    right: 12px;
    width: 44px !important;
    height: 44px !important;
  }

  .scroll-to-top-btn :deep(.q-btn__content) {
    font-size: 18px;
  }
}

.scroll-to-top-btn:active {
  transform: scale(0.95);
}
</style>
